"use strict";

exports.__esModule = true;
exports.default = void 0;

var visuallyHidden = function visuallyHidden() {
  return "\n  border: 0!important;\n  box-sizing: border-box;\n  clip: rect(1px, 1px, 1px, 1px) !important;\n  height: 1px !important;\n  overflow: hidden !important;\n  padding: 0 !important;\n  position: absolute !important;\n  top: 0;\n  width: 1px !important;\n";
};

var _default = visuallyHidden;
exports.default = _default;